import React from "react";

interface RewardsTabIconProps {
  className?: string;
}

export const RewardsTabIcon = ({ className }: RewardsTabIconProps) => (
  <svg
    width="18"
    height="16"
    viewBox="0 0 18 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M14 2H17.625C17.875 2 18 2.125 18 2.375V4.3125C18 5.3125 17.5104 6.28125 16.5312 7.21875C15.5729 8.15625 14.3854 8.72917 12.9688 8.9375C12.5521 9.83333 12.0312 10.5312 11.4062 11.0312C10.7812 11.5312 10.1458 11.8438 9.5 11.9688V15H12.1875C12.4167 15 12.6042 15.0729 12.75 15.2188C12.9167 15.3854 13 15.5833 13 15.8125C13 15.9375 12.9375 16 12.8125 16H5.1875C5.0625 16 5 15.9375 5 15.8125C5 15.5833 5.07292 15.3854 5.21875 15.2188C5.38542 15.0729 5.58333 15 5.8125 15H8.5V11.9688C8.08333 11.8854 7.67708 11.7292 7.28125 11.5C6.88542 11.2708 6.47917 10.9375 6.0625 10.5C5.66667 10.0625 5.32292 9.54167 5.03125 8.9375C3.61458 8.72917 2.41667 8.15625 1.4375 7.21875C0.479167 6.28125 0 5.3125 0 4.3125V2.375C0 2.125 0.125 2 0.375 2H4V0.375C4 0.125 4.125 0 4.375 0H13.625C13.875 0 14 0.125 14 0.375V2ZM1 4.3125C1 4.97917 1.33333 5.66667 2 6.375C2.6875 7.0625 3.54167 7.54167 4.5625 7.8125C4.1875 6.625 4 5.27083 4 3.75V3H1V4.3125ZM6.15625 8.875C6.92708 10.2917 7.875 11 9 11C10.125 11 11.0729 10.2917 11.8438 8.875C12.6146 7.45833 13 5.75 13 3.75V1H5V3.75C5 5.75 5.38542 7.45833 6.15625 8.875ZM17 4.3125V3H14V3.75C14 5.27083 13.8125 6.625 13.4375 7.8125C14.4583 7.54167 15.3021 7.0625 15.9688 6.375C16.6562 5.66667 17 4.97917 17 4.3125Z"
      fill="#666666"
    />
  </svg>
);

RewardsTabIcon.defaultProps = {
  className: "",
};
